import { useTheme } from "@mui/material";
import { useMemo } from "react";
function useStyles(props) {
  const { align = "left", gap = 2, padding = 1, sx } = props;
  const theme = useTheme();
  const { spacing } = theme;
  return useMemo(() => {
    let alignment = "flex-start";
    switch (align) {
      case "left":
        alignment = "flex-start";
        break;
      case "center":
        alignment = "space-around";
        break;
      case "right":
        alignment = "right";
        break;
    }
    const sxResolved = typeof sx === "function" ? sx(theme) : sx;
    return {
      ...sxResolved,
      "--form-footer-gap": spacing(gap),
      "--form-footer-padding": spacing(padding),
      "--form-footer-alignment": alignment
    };
  }, [sx, spacing, align, gap, padding, theme]);
}
export {
  useStyles
};
//# sourceMappingURL=useStyles.js.map
